import React from "react";

const JobsIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.2 3.83594H0V18.2359H19.2V3.83594Z" fill="#5D5D5D" />
      <path
        d="M14.3969 0.236328H4.79688V3.83633H14.3969V0.236328Z"
        fill="#5D5D5D"
      />
      <path d="M0 11.0361H19.2" stroke="white" stroke-width="1.2" />
    </svg>
  );
};

export default JobsIcon;
